var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.836 2.091a8.483 8.483 0 0 1-2.495.702A4.449 4.449 0 0 0 21.25.327c-.84.51-1.768.881-2.76 1.08A4.284 4.284 0 0 0 15.319 0c-2.398 0-4.344 1.997-4.344 4.459 0 .35.037.689.112 1.015-3.612-.186-6.813-1.96-8.958-4.66a4.543 4.543 0 0 0-.588 2.244A4.49 4.49 0 0 0 3.474 6.77a4.264 4.264 0 0 1-1.969-.556v.055c0 2.161 1.498 3.964 3.487 4.372a4.141 4.141 0 0 1-1.145.157c-.28 0-.553-.027-.818-.08.554 1.772 2.157 3.062 4.06 3.096a8.577 8.577 0 0 1-6.434 1.849 12.093 12.093 0 0 0 6.661 2.001c7.994 0 12.364-6.793 12.364-12.686 0-.194-.003-.388-.01-.578a8.923 8.923 0 0 0 2.166-2.308",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f9554983bb0b80ec5b3f79329a031e8c.svg";
export { ForwardRef as ReactComponent };